import { Route, Routes } from 'react-router';

import { MomentmSettingsRouteActions } from './actions/MomentmSettingsRouteActions';
import { MTMSettingsRouteActions } from './actions/MTMSettingsRouteActions';

export function AdminRouteActions() {
  return (
    <Routes>
      <Route element={<MTMSettingsRouteActions />} path="mtm" />
      <Route element={<MomentmSettingsRouteActions />} path="momentm" />
    </Routes>
  );
}
